import { AfterViewInit, ChangeDetectionStrategy, Component, viewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ComboBoxComponent, ComboBoxModule, DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { ICellEditorAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'select-cell-editor',
  styleUrls: ['./pxd-ag-grid-select-editor.scss'],
  template: `<kendo-combobox #kendoCombobox (valueChange)="onValueChange($event)" [filterable]="true"
                                [kendoDropDownFilter]="filterSettings" [readonly]="readonly" (filterChange)="onFilterChange()"
                                [clearButton]="clearButton" style="width:100%" [data]="dropdownData"  [virtual]="virtual" [listHeight]="listHeight"
                                textField="text" [popupSettings]="popupSettings" valueField="value" [valuePrimitive]="true" [(ngModel)]="value">
                              
                                @if (showEquationTemplate) {
                                  <ng-template kendoComboBoxItemTemplate let-dataItem>
                                    <div class="item-container">
                                      <div class="description-column"><strong>{{ dataItem.description }}</strong></div>
                                      <div class="value-column">{{ dataItem.text }}</div>
                                    </div>
                                  </ng-template>
                                }
                              
                              </kendo-combobox>`,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ComboBoxModule,
    FormsModule,
  ],
})

export class PxdAgGridSelectEditorComponent implements ICellEditorAngularComp, AfterViewInit {

  public popupSettings: any = {
    width: 150,
  };

  public listHeight: number = 200;

  public dropdownData: any;
  public value: any;
  public clearButton: boolean;
  public onChange: Event;
  public readonly: boolean = false;
  public showEquationTemplate: boolean = false;

  public virtual: any = {
    itemHeight: 28,
  };

  private readonly kendoCombobox = viewChild<ComboBoxComponent>('kendoCombobox');

  private params: any;

  public filterSettings: DropDownFilterSettings = {
    caseSensitive: false,
    operator: "contains",
  };

  public agInit(params: any): void {
    this.params = params;
    this.value = params.value;
    this.dropdownData = params.values;
    this.showEquationTemplate = params.showEquationTemplate;
    this.clearButton = params.clearButton !== false;
    this.readonly = params.readonly;
    if (params.popupHeight) {
      this.listHeight = params.popupHeight;
    }
    if (params.popupWidth) {
      this.popupSettings.width = params.popupWidth;
    }
  }

  public ngAfterViewInit(): void {
    if (this.params.onValueChange) {
      this.kendoCombobox().valueChange.subscribe((data) => {
        this.params.onValueChange(data);
      })
    }
    this.kendoCombobox().close.subscribe((data) => {
    })
    if (this.params.onFilterChange) {
      this.kendoCombobox().filterChange.subscribe((data) => {
        this.params.onFilterChange(data);
      })
    }
  }

  public onValueChange(value: any): void {
    this.value = value;
    if (this.params?.stopEditing) {
      this.params.stopEditing();
    }
  }

  public onFilterChange(): void {
    this.dropdownData = this.params.values;
  }

  public getValue(): any {
    return this.value;
  }
}